/*
 * Copyright (c) 2017-2018. Code réalisé par IpsoSenso
 */

import { messages } from '@dgac/oceane-ui'
import { flatten } from 'flat'
import { messages as messagesIsotope } from 'isotope-client'
import { EXAMEN_CANDIDAT_ETAT } from '@dgac/oceane-ui'
import { RESULTATS_EXAMEN_CCAP } from '../modules/examens/services/examens.enums'

export default flatten({
	...messagesIsotope,
	...messages,
	accueil: 'Accueil',
	parent: 'Parent',
	menu: {
		etatCivil: 'Mon état civil',
		examens: 'Mes examens',
		historique: 'Mon historique',
		motDePasse: 'Mon mot de passe',
		contacts: 'Mes contacts DGAC',
		informations: 'Informations utiles'
	},
	tooltip: {
		manuel: 'Manuel',
		deconnexion: 'Déconnexion',
		'changer-profil': 'Changer de profil'
	},
	connexion: {
		authentification: 'Authentification',
		identifiant: 'Identifiant Oceane ou adresse mail *',
		motDePasse: 'Mot de passe *',
		motDePasseOublie: 'Mot de passe oublié',
		cliquerIci: 'cliquer ici',
		autreProblemeConnexion: 'Pour tout autre problème de connexion, envoyez un mail à :',
		creerCompte: 'Créer un compte',
		meConnecter: 'Me connecter',
		creationCompteSucces: 'Votre compte a été créé avec succès. Vous allez recevoir un message électronique contenant vos informations d\'accès.'
	},
	form: {
		motDePasse: {
			champs: {
				identifiant: 'Identifiant (adresse mail saisie dans OCEANE) *',
				motDePasseActuel: 'Mot de passe actuel *',
				nouveauMotDePasse: 'Nouveau mot de passe *',
				confirmerMotDePasse: 'Confirmation du nouveau mot de passe *'
			},
			erreurs: {
				motDePasseIncorrect: 'Mot de passe incorrect',
				nouveauMotDePasse: 'Votre mot de passe doit comporter au minimum 8 caractères, au moins une minuscule, au moins une majuscule et au moins un chiffre',
				confirmerMotDePasse: 'Le nouveau mot de passe et sa confirmation sont différents',
				tokenInvalide: 'Le lien de renouvellement que vous avez utilisé n\'est plus valide. Veuillez effectuer une nouvelle demande.'
			},
			warning: 'Veillez à bien mémoriser votre mot de passe qui est personnel et confidentiel. Pour des raisons de sécurité, il ne vous sera pas rappelé ultérieurement.',
			succes: 'Mot de passe enregistré',
			genererSucces: 'Vous recevrez un mail vous permettant de réinitialiser votre mot de passe si l\'adresse mail renseignée est correcte.',
			renouveler: 'Renouveler votre mot de passe',
			generer: 'Génerer un nouveau mot de passe'
		},
		creerCompte: {
			titre: 'Créer un compte Oceane',
			selectionCategorie: 'Choisissez votre catégorie',
			categorie: 'Catégorie',
			selectionExamen: 'Sélectionnez vos examens',
			warning: {
				selection: 'ATTENTION, vous ne devez pas créer un compte OCEANE si vous en possédez déjà un !',
				etatCivil: 'Merci de respecter scrupuleusement les informations indiquées sur votre pièce d\'identité (carte nationale d\'identité ou passeport)'
			},
			erreurs: {
				emailExistant: 'L\'adresse électronique que vous avez saisie possède déjà un compte Océane',
				doublonMemeEmail: 'Un compte OCEANE portant l\'adresse éléctronique saisie existe déjà. Vous pouvez annuler la création de compte et utiliser la fonctionnalité "Mot de passe oublié" pour récupérer l\'accès à votre compte au besoin',
				doublon: 'Votre compte Oceane ne peut pas être créé car il existe déjà. Pour plus d\'informations, veuillez prendre contact avec les gestionnaires logistiques de la DGAC ({0})'
			}
		},
		global: {
			erreurs: {
				obligatoire: 'Champ obligatoire'
			}
		}
	},
	examens: {
		titre: 'Mes examens',
		aide: '<b>Objectif (seulement pour les examens théoriques)</b><ul><li>Obtention de l\'examen : vous êtes inscrits à cet examen en vue de l\'obtention du diplôme correspondant</li><li>Validation d\'épreuves : vous êtes inscrits en vue de valider une ou plusieurs de ces épreuves</li></ul><br/><b>Etat</b> - indique l\'état courant de votre examen :<ul><li>Créé = l\'examen a été créé mais ne comporte encore aucune inscription</li><li>En cours = l\'examen comporte une ou plusieurs inscriptions</li><li>Réussi = l\'examen a été réussi</li><li>Edité / Transmis = si vous avez passé un examen théorique, le diplôme a été édité ; si vous avez passé un examen pratique, le dossier a été transmis au bureau des licences</li><li>Abandonné = l\'examen a été abandonné en cours de passage</li><li>Echoué = l\'examen a été échoué</li><li>Fraude = l\'examen a été échoué pour cause de fraude</li></ul>\n',
		objectif: {
			1: 'Obtention du diplôme (paiement au forfait)',
			2: 'Validation d\'épreuves (paiement à l\'épreuve)'
		},
		etat: {
			[EXAMEN_CANDIDAT_ETAT.CREE]: 'Créé',
			[EXAMEN_CANDIDAT_ETAT.EN_COURS]: 'En cours',
			[EXAMEN_CANDIDAT_ETAT.REUSSI]: 'Réussi',
			[EXAMEN_CANDIDAT_ETAT.ECHOUE]: 'Echoué',
			[EXAMEN_CANDIDAT_ETAT.EDITE]: 'Edité',
			[EXAMEN_CANDIDAT_ETAT.ABANDONNE]: 'Abandonné',
			[EXAMEN_CANDIDAT_ETAT.FRAUDE]: 'Fraude'
		},
		le: ' le ',
		certificat: 'Certificat',
		resultats: {
			btn: 'Résultats',
			popin: {
				titre: "Résultats à l'examen",
				[RESULTATS_EXAMEN_CCAP.SCO]: "Note Secourisme",
				[RESULTATS_EXAMEN_CCAP.SCU]: "Note Sécurité",
				[RESULTATS_EXAMEN_CCAP.ELIMINATION]: "Elimination Piscine",
				noteEpreuve: "{note} / 20",
				booleanElimination: {
					true: 'Oui',
					false: 'Non'
				}
			}
		},
		nouveau: {
			titre: 'Nouvel examen',
			categorie: 'Choisissez votre catégorie',
			examenType: 'Examen type',
			categorieExamenType: {
				1: 'Théorique professionnels',
				2: 'Pratique',
				3: 'Compétences linguistiques',
				4: 'Théorique privés'
			},
			check: 'J\'ai bien pris connaissance des informations concernant cet examen.',
			erreur: {
				dejaExistant: 'Vous possédez déjà un examen en cours ou initialisé pour cet examen type. Veuillez consulter la liste de vos examens.'
			}
		}
	},
	inscriptions: {
		title: 'Inscriptions à l\'examen',
		aide: '<b>Etat</b> - indique l\'état courant de votre inscription :<ul><li>Créée, Figée = l\'inscription a été créée; elle est en cours d\'affectation dans un centre</li><li>Affectée = l\'inscription a été affectée dans un centre</li><li>En cours = les épreuves sont en cours de passage</li><li>Terminée = toutes les épreuves sont terminées</li><li>Abandonnée = l\'inscription a été abandonnée en cours de passage</li></ul>',
		aidePratique: '<b>Etat</b> - indique l\'état courant de votre inscription :<ul><li>Créée = l\'inscription a été créée</li><li>En cours = l\'inscription est en cours</li><li>Terminée = l\'inscription est terminée</li><li>Abandonnée = l\'inscription a été abandonnée</li></ul>',
		aideValidationEpreuves: '<span class="titre">Pour toute nouvelle inscription, vous pouvez :</span><ul><li>Remplir et envoyer un formulaire au centre des examens de la DGAC (les formulaires d\'inscription sont disponibles sur notre site institutionnel <a href="http://www.aviation-civile.gouv.fr">www.aviation-civile.gouv.fr</a>)</li><li>Vous adresser directement au guichet du centre des examens d\'Orly</li></ul>',
		etat: {
			1: 'Créée',
			2: 'Figée',
			3: 'Affectée',
			4: 'En cours',
			5: 'Terminée',
			6: 'Abandonnée'
		},
		type: {
			1: 'écran',
			2: 'papier',
			3: 'mixte',
			4: 'pratique'
		},
		piecesJustificativesDossier: {
			title: 'Vos pièces justificatives',
			button: 'Pièces justificatives',
			statutDossier: {
				1: 'Vos pièces justificatives sont à compléter pour que votre inscription puisse être validée. Veuillez nous les transmettre en utilisant le lien ci-dessous.',
				2: 'Vos pièces justificatives sont en cours de validation par la DGAC. Un mail vous informera de l\'issue de nos vérifications.',
				3: 'Certaines des pièces ou informations transmises ont été jugées non conformes par la DGAC. Veuillez les remplacer en utilisant le lien ci-dessous.',
				4: 'Vos pièces justificatives ont été validées par la DGAC. Vous pouvez vous présenter à l\'examen dans les conditions indiquées par votre fiche d\'inscription accessible dans la liste ci-dessous.'
			},

			warningNonConforme: {
				title: 'Dossier non conforme'
			},
			infosComplementaires: {
				title: 'Informations complémentaires',
				form: {
					noTelepilote: 'Votre numéro de télépilote *',
					dateExpirationCertifBapd: 'Date d\'expiration de votre certificat BAPD *',
					dateExpirationCertifA1A3: 'Date d\'expiration de votre certificat Open A1/A3 *',
					isTitulaireBapd: 'Êtes-vous titulaire du BAPD ? *',
					erreurs: {
						noTelepiloteSuffixeNbCaracteres: 'Veuillez saisir 12 caractères alphanumériques',
						certifExpireAvantDerniereEpreuve: 'Votre certificat A1/A3 expire avant le passage de votre dernière épreuve'
					},
					buttons: {
						envoyer: 'Envoyer'
					}
				}
			},
			listePJ: {
				title: 'Envoi des pièces justificatives',
				warning: {
					title: 'Important',
					description: (
						'Les documents fournis doivent posséder l\'une des extensions suivantes&nbsp;: <Strong>.pdf .jpg .jpeg .png .gif</Strong><br>' +
						'Ils doivent être de <Strong>bonne qualité</Strong> et orientés dans le <Strong>sens de la lecture</Strong>.<br>' +
						'Le poids de chaque document ne doit pas excéder <Strong>20 Mo</Strong>.'
					)
				},
				status: {
					nonConforme: 'non conforme',
					validee: 'validée',
				},
				fileNotExist: 'Le fichier a été supprimé'
			},
			envoyer: {
				dossierNonComplet: 'Toutes les pièces justificatives obligatoires doivent être fournies pour transmettre votre dossier'
			},
			messages: {
				createPjSuccess: 'La pièce justificative {fileName} a bien été enregistrée',
				deletePjSuccess: 'La pièce justificative {fileName} a bien été supprimée',
				dossierValideSuccess: 'Le dossier a bien été envoyé pour validation',
			}
		},
		vosInscriptions: {
			title: 'Vos inscriptions'
		},
		sessionPapier: 'Session papier {libelleSession}',
		passageEcran: 'Passage écran du {dateDebut} au {dateFin}',
		passageEcranShort: 'Du {dateDebut} au {dateFin}',
		inscription: 'Inscription',
		inscriptionType: 'Inscription {type}',
		lettreResultat: 'Lettre de résultats',
		convocation: 'Convocation',
		piecesJustificatives: 'Pièces justificatives',
		ficheInscription: 'Fiche inscription',
		ficheRecap: 'Fiche récapitulative d\'inscription',
		aucune: 'Il n\'y a aucune inscription pour cet examen',
		nouveau: {
			title: 'Nouvelle inscription',
			ecran: 'Ecran',
			papier: 'Papier',
			session: 'Session',
			niveau6: 'Niveau 6',
			erreurs: {
				examenEchoueNonExceptionnel: 'Seule une inscription exceptionnelle est possible pour un examen échoué',
				examenTermine: 'Aucune nouvelle inscription ne peut être créée pour un examen réussi, édité, abandonné ou déclaré en fraude',
				inscriptionsNonFinales: 'L\'inscription en cours doit être terminée avant la création d\'une nouvelle inscription',
				delaiDepasse: 'La session choisie excède le délai maximal d\'obtention de l\'examen',
				examenTypeDesactive: 'Il n\'est plus possible de créer d\'inscriptions pour cet examen',
				examenNonEcran: 'Cet examen ne peut être passé sur écran'
			},
			avertissement: {
				title: 'Vous vous apprêtez à créer une inscription pour l\'examen <Strong>{examenType}</Strong> :',
				message: '<ul><li> 1) Assurez-vous que l\'examen sélectionné est correct car celui-ci ne sera pas modifiable une fois l\'inscription enregistrée. Si vous avez fait une erreur dans le choix de l\'examen, interrompez l\'inscription en cliquant sur le bouton "ANNULER". </li><li> 2) L\'inscription ne sera enregistrée que lorsque le paiement sera accepté. Assurez-vous d\'avoir votre carte de paiement à disposition car votre temps de connexion est limité. </li><li>3) ATTENTION : Une fois enregistrée, votre inscription n\'est ni modifiable, ni remboursable. Assurez-vous d\'avoir selectionné le bon examen et renseigné correctement les paramètres de votre inscription. </li><li> 4) Cliquez sur le bouton "OK" pour continuer. </li></ul>',
				inscriptionAttentePaiement: 'Vous avez déjà effectué une tentative d\'inscription dans la journée. Cette inscription est en attente de confirmation de paiement.<br/>' +
					'<br/>' +
					'Si vous avez reçu un ticket de paiement par mail concernant cette inscription, cela signifie qu\'elle est en cours de finalisation. Vous recevrez un mail de confirmation d\'inscription sous 2 heures.<br/>' +
					'<br/>' +
					'Si vous n\'avez pas validé le paiement, nous vous invitons à renouveler votre démarche d\'inscription dès demain matin.<br/>' +
					'<br/>' +
					'Nous attirons votre attention sur le fait que toute demande auprès du service des examens d\'Orly ne pourra être traitée que sur justificatif du respect des consignes ci-dessus.<br/>'
			}
		},
		payfip: 'Votre paiement a été accepté. Votre inscription est en cours. Pour la valider, merci d\'envoyer au plus vite les pièces justificatives.',
		warningKsaTitle: 'Avertissement pour une inscription à une première épreuve d\'examen après le 01.08.2021',
		warningKsa: 'Depuis le 1er août 2021 toute nouvelle inscription à une première épreuve d’examen théorique s’effectue selon les nouveaux objectifs de formation 100 KSA.<br/>' +
			'<br/>' +
			'Les épreuves des examens théoriques ATPL, CPL ou IR répondant aux anciens objectifs de formation (avant 100 KSA) ne peuvent plus être passées, sauf par des candidats ayant déjà passé au moins une épreuve de ces mêmes examens antérieurement.<br/>' +
			'Pour pouvoir réussir complètement un de ces examens théoriques, toutes les épreuves le composant doivent être réussies avant le 31 juillet 2022.<br/>' +
			'Si, à cette date un candidat n’a pas réussi toutes les épreuves de l’examen théorique requis, il perdra le bénéfice des épreuves réussies<br/>' +
			'<br/>' +
			'Équivalences d’épreuves théoriques entre les anciens examens et les examens 100KSA.<br/>' +
			'Conformément à l’AMC1 FCL.025(a)(2) un candidat doit suivre une formation complète 100KSA avant le passage de l’examen.<br/>' +
			'De ce fait l’ATO devra attester que le candidat a suivi de façon complète et satisfaisante la formation 100KSA dans sa totalité, y compris pour les matières pour lesquelles l’équivalence est demandée.<br/>' +
			'Cas particulier des communications : seuls les candidats ayant obtenu les épreuve de communications VFR (091) + IFR (092) pourront bénéficier d’une équivalence (090)<br/>'
	},
	nouvelleInscription: {
		etapes: {
			2: {
				erreurs: {
					dateLimiteKSA: 'Vous ne pouvez pas passer la première épreuve d\'un examen professionnel nouvelle formule avant le {dateLimite}',
					dateLimiteAvantKSA: 'Vous ne pouvez pas passer la première épreuve d\'un examen professionnel ancienne formule après le {dateLimite}'
				}
			}
		}
	},
	updateEmail: {
		success: 'Votre email a été mis à jour',
		error: 'Votre demande n\'a pu aboutir. Il se peut que le lien que vous ayez utilisé soit périmé'
	}
})
